(() => {
  const config = document.currentScript?.dataset;
  if (!config) return;
  const key = 'ayaq:breadcrumb:next';
  const stateKey = 'ayaqBreadcrumb';
  const maxAge = 30 * 60 * 1000;

  function localUrl(value) {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url : null;
    } catch { return null; }
  }
  function productPath(value) {
    const url = localUrl(value);
    const match = url?.pathname.match(/^(.*?)(?:\/collections\/[^/]+)?\/products\/([^/]+)\/?$/);
    return match ? `${match[1]}/products/${match[2]}` : '';
  }
  function returnUrl(value) {
    const url = localUrl(value);
    if (!url || !/\/(collections\/[^/]+|search)\/?$/.test(url.pathname)) return '';
    // Keep visitor filters and search terms, but no tracking/preview parameters.
    for (const name of [...url.searchParams.keys()]) {
      if (!name.startsWith('filter.') && !['q', 'type', 'sort_by', 'page', 'options[prefix]'].includes(name)) {
        url.searchParams.delete(name);
      }
    }
    return url.pathname + url.search;
  }
  function valid(record) {
    return record && typeof record.title === 'string' && record.title.trim() &&
      record.title.length <= 500 && record.product === productPath(window.location.href) &&
      Number.isFinite(record.at) && Date.now() >= record.at && Date.now() - record.at < maxAge &&
      Boolean(returnUrl(record.url));
  }
  function remember(event) {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
    const product = productPath(anchor.href);
    if (!product) return;
    try {
      // A new product navigation must never reuse an unrelated earlier click.
      sessionStorage.removeItem(key);
      const panel = anchor.closest('ayaq-search-panel');
      let title = '';
      let url = '';
      if (panel) {
        const search = localUrl(config.searchUrl);
        if (!search) return;
        search.searchParams.set('q', (panel.querySelector('[data-search-input]')?.value || '').trim());
        search.searchParams.set('options[prefix]', 'last');
        for (const input of panel.querySelectorAll('[data-search-filter-type]:checked')) {
          const name = input.dataset.searchFilterParam;
          const value = input.dataset.searchFilterValue;
          if (name?.startsWith('filter.') && value && !search.searchParams.getAll(name).includes(value)) {
            search.searchParams.append(name, value);
          }
        }
        url = returnUrl(search.href);
        title = config.searchLabel;
      } else if (config.pageType === 'collection') {
        url = returnUrl(window.location.href);
        title = config.collectionTitle;
      } else if (config.pageType === 'search') {
        url = returnUrl(window.location.href);
        title = config.searchLabel;
      }
      if (!title || !url) return;
      sessionStorage.setItem(key, JSON.stringify({
        product, title, url, at: Date.now(), source: window.location.pathname,
      }));
    } catch { /* Storage is optional: retain the server-rendered breadcrumb. */ }
  }
  function apply() {
    const link = document.getElementById('breadcrumb-collection-link');
    if (!link || !productPath(window.location.href)) return;
    let record;
    try {
      const pending = JSON.parse(sessionStorage.getItem(key) || 'null');
      sessionStorage.removeItem(key);
      const referrer = localUrl(document.referrer);
      if (valid(pending) && referrer?.pathname === pending.source) record = pending;
    } catch { /* A blocked or damaged store must not interrupt navigation. */ }
    // History state belongs to this exact visit, even if the same product was
    // subsequently opened from a different collection. It also survives reload.
    if (!record && valid(window.history.state?.[stateKey])) record = window.history.state[stateKey];
    if (!record) return;
    link.href = returnUrl(record.url);
    link.textContent = record.title;
    try {
      window.history.replaceState({ ...window.history.state, [stateKey]: record }, '', window.location.href);
    } catch { /* The visible breadcrumb still works if history storage fails. */ }
  }
  document.addEventListener('click', remember, { capture: true });
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('pageshow', apply);
})();
